import replace from "lodash/replace";
import trim from "lodash/trim";
function DottedBackground() {
    const dotColor = "#3c4b5779";
    const dotRadius = 1;
    const dotSpacing = 40;
    const svg = replace(trim(`
    <svg xmlns="http://www.w3.org/2000/svg"
         width="${dotSpacing}"
         height="${dotSpacing}">
      <circle cx="${dotSpacing / 2}"
              cy="${dotSpacing / 2}"
              r="${dotRadius}"
              fill="${dotColor}"/>
    </svg>
  `), /\s+/g, " ");
    return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
}
export default DottedBackground;
